// @ts-check

/** @type { Partial<CabD.A.ContainerConfigs.ContainerConfig> } */
export const OneDrawerOneDoorBlindCornerRight = {
  height: 36,
  depth: 24,
  width: 46,
  name: '1 Drawer 1 Door Blind Corner Right',
  isTopLevel: true,
  children: [
    {
      name: 'ToeKickAssembly',
      layout: 'DEPTH',
      height: 3,
      children: [
        {
          name: 'ToeKickFinishEnds',
          layout: 'WIDTH',
          children: [
            {
              width: 0.5,
              type: 'Panel',
              name: 'ToeKickAssembly--LeftPanel'
            },
            {
              name: 'ToeKickAssembly--HollowCenter'
            },
            {
              width: 0.5,
              type: 'Panel',
              name: 'ToeKickAssembly--RightPanel'
            }
          ]
        },
        {
          name: 'ToeKickAssembly--FrontPanel',
          type: 'Panel',
          depth: 0.5
        },
        {
          name: 'ToeKickAssembly--ToeKickSetBack',
          depth: 2
        }
      ]
    },
    {
      name: 'BaseAssembly',
      layout: 'DEPTH',
      children: [
        {
          name: 'BaseCarcassAssembly',
          layout: 'WIDTH',
          children: [
            {
              name: 'BaseLeftSide',
              type: 'Panel',
              width: 0.5
            },
            {
              name: 'BaseCarcassAssembly--InteriorAssembly',
              children: [
                {
                  name: 'BaseBottom',
                  height: 0.5,
                  type: 'Panel'
                },
                {
                  name: 'BaseInteriorAssembly',
                  layout: 'DEPTH',
                  children: [
                    {
                      name: 'BaseBack',
                      type: 'Panel',
                      depth: 0.5
                    },
                    {
                      name: 'BaseInterior',
                      children: [
                        {
                          name: 'Interior',
                          children: [
                            {},
                            {
                              height: 0.5,
                              type: 'Panel',
                              name: 'Shelf'
                            },
                            {},
                            {
                              height: 0.5,
                              type: 'Panel',
                              name: 'Shelf'
                            },
                            {}
                          ]
                        },
                        {
                          name: 'BaseFullTop',
                          type: 'Panel',
                          height: 0.5
                        }
                      ]
                    },
                    {
                      name: 'BlindPanelAssembly',
                      depth: 0.5,
                      layout: 'WIDTH',
                      children: [
                        {},
                        {
                          name: 'BlindPanel',
                          type: 'Panel',
                          width: 23
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'BaseRightSide',
              width: 0.5,
              type: 'Panel'
            }
          ]
        },
        {
          name: 'FrontExteriorAssembly',
          layout: 'WIDTH',
          depth: 0.5,
          children: [
            {
              name: 'LeftDoorOverlay',
              width: 0.25
            },
            {
              name: 'FrontAssembly',
              children: [
                {
                  name: 'BottomReveal',
                  height: 0.25
                },
                {
                  name: '1Door',
                  layout: 'WIDTH',
                  children: [
                    {
                      layout: 'HEIGHT',
                      children: [
                        {
                          handleOrientation: 'VERTICAL',
                          handlePosition: {
                            oX: {
                              type: 'toRight',
                              value: 3
                            },
                            oY: {
                              type: 'toTop',
                              value: 3
                            },
                            oZ: 'onSurface'
                          },
                          type: 'Door',
                          name: 'Door--DoorPanel'
                        }
                      ]
                    },
                    {
                      width: 23
                    }
                  ]
                },
                {
                  name: 'Reveal',
                  height: 0.25
                },
                {
                  name: '1Drawer',
                  layout: 'WIDTH',
                  height: 6,
                  children: [
                    {
                      layout: 'HEIGHT',
                      children: [
                        {
                          handlePosition: {
                            oX: {
                              type: 'center',
                              value: null
                            },
                            oY: {
                              type: 'center',
                              value: null
                            },
                            oZ: 'onSurface'
                          },
                          type: 'Door',
                          name: 'Door--DoorPanel'
                        }
                      ]
                    },
                    {
                      width: 23
                    }
                  ]
                },
                {
                  name: 'TopReveal',
                  height: 0.25
                }
              ]
            },
            {
              name: 'RightDoorOverlay',
              width: 0.25
            }
          ]
        }
      ]
    }
  ],
  countertopMaterialName: 'marblewhite005'
};


